module.exports = __webpack_public_path__ + "img/compresor-2.70059acf.png";